// This file is responsible for saving and loading the configurator state
// to IndexedDB.
import * as localForage from 'localforage';
import { objectURLToBase64, base64ToObjectURL } from "~/scripts/Pipeline/_helpers.js";

const storageName = 'ayvstore';

localForage.config({
    driver: localForage.INDEXEDDB,
    name: storageName,
    version: 1.0
});

//--------------------------------------------------------------
// ENCODE: sound to string
//--------------------------------------------------------------

/**
 * Convert all files in state
 * @param state
 * @return {Promise<*>}
 */
var convertSoundFilesToString = async(state) => {
    for(let idx in state.soundFiles) {
        // check that idx is not inherited
        if(!state.soundFiles.hasOwnProperty(idx)) {
            continue;
        }

        try {
            state.soundFiles[idx].url = await objectURLToBase64(state.soundFiles[idx].url);
        }
        catch(e) {
            throw 'SoundFile ' + idx + ' is not a valid data url';
        }
    }

    if(state.extraSound.soundFile) {
        try {
            state.extraSound.soundFile = await objectURLToBase64(state.extraSound.soundFile);
        }
        catch(e) {
            throw 'Extra soundFile is not a valid data url';
        }
    }

    return state;
};



//--------------------------------------------------------------
// DECODE: string to sound
//--------------------------------------------------------------

var convertSoundFilesToDataURL = (state) => {
    state.soundFiles.forEach((soundFile, idx) => {
        try {
            state.soundFiles[idx].url = base64ToObjectURL(state.soundFiles[idx].url);
        }
        catch(e) {
            throw 'SoundFile ' + idx + ' is not a valid base64 string';
        }
    });

    if(state.extraSound.soundFile) {
        try {
            state.extraSound.soundFile = base64ToObjectURL(state.extraSound.soundFile);
        }
        catch(e) {
            throw 'Extra soundFile is not a valid base64 string';
        }
    }

    return state;
};





//--------------------------------------------------------------
// Methods that get exported
//--------------------------------------------------------------

async function saveState(state) {
    let jsonState = JSON.parse(JSON.stringify(state));

    // convert soundfiles to base64 string so we can easily store it
    jsonState = await convertSoundFilesToString(jsonState);

    localForage.setItem('state', jsonState);
}

async function deleteState() {
    localForage.removeItem('state');
}

async function loadState() {
    try {
        let state = await localForage.getItem('state');

        state = await convertSoundFilesToDataURL(state);

        return state;
    }
    catch(e) {
        // do not load state if there was an error loading it
        return null;
    }
}

export default {
    saveState,
    loadState,
    deleteState
}
